import { useState, useEffect } from 'react';
import { Row, Col, Button, Card, CardBody, CardHeader, Collapse, Input } from 'reactstrap';
import { FaChevronUp, FaChevronDown, FaSlash } from 'react-icons/fa';
import uuid from 'react-uuid';
import { ToastContainer, toast as toastytoast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Tooltip as ReactTooltip } from "react-tooltip";

const ItemTypeListViewForMap = ({ Section, itemTypesList, toggleItemTypeListState, handleClearSelection, handleItemClick, handleItemTypeListTogole, isWizardCompleted, itemModel, gisLayerDetails, handleGISLayerDetails, gisLayerStockExclusionLandSlopeDetails, handleGISLayerStockExclusionLandSlopeDetails }) => {

    const [isOpen, setIsOpen] = useState(!isWizardCompleted);
    const [isIconUp, setIsIconUp] = useState(!isWizardCompleted);
    const [isCropping, setIsCropping] = useState(false);
    const [isWaterways, setIsWaterways] = useState(false); const [isIrrigation, setIsIrrigation] = useState(false);
    const [isLandErosion, setIsLandErosion] = useState(false);
    const [isOther, setIsOther] = useState(true);
    const toggle = () => {
        setIsOpen(!isOpen)
        setIsIconUp(!isIconUp)
        handleItemTypeListTogole(!isOpen, !isIconUp);
    };
    useEffect(() => {
        if (Section == 'Cropping') {
            setIsCropping(true);
            setIsOther(false);
        }
        else if (Section == 'Land and Erosion') {
            setIsLandErosion(true);
            setIsOther(false);
        }
        else if (Section == 'WaterwaysMap' || Section == 'WaterwaysRisk') {
            setIsWaterways(true);
            setIsOther(false);
        }
        else if (Section == 'Irrigation') {
            setIsIrrigation(true);
            setIsOther(false);
        }
    }, []);
    const CustomToastWithLink = (message) => (
        <div>
            <p>{message}</p>
        </div>
    );
    const customId = "custom-id-yesItem";
    const showToastMessage = (e,message) => {
        e.stopPropagation();
        toastytoast.info(CustomToastWithLink(message), {
            autoClose: false, theme: "colored", hideProgressBar: true, icon: false, toastId: customId, rtl: false
        });
    };

    return (
        <Card className="cardNonLeftRadius" >
            <CardHeader className="item-header item_click card-header1">
                <Row className="itemTypeList-header-div">


                    {Section == 'Community & Cultural Significance' &&
                        <Col><Row> <h5 className="text-capitalize fw-bold color-dark-teal">Mapping of Culturally or Community Significant Sites and Species&nbsp;&nbsp;
                            <img className="featureIcon" src="/images/info_button_lt.png" data-tooltip-id="my-tooltip-15" onClick={(e) => e.stopPropagation()} /></h5>
                            <ReactTooltip opacity="1" className="overrideMe" globalCloseEvents={{ escape: true, clickOutsideAnchor: true, scroll: true, resize: true }} openOnClick="true" clickable="true" style={{ marginTop: "-1vh", backgroundColor: "#e2f2f3", color: "black", maxWidth: "25vw", fontWeight: "750", wordBreak: 'normal', overflowWrap: 'break-word' }}
                                id="my-tooltip-15"
                                place="top"
                                variant="info"
                                render={({ content, activeAnchor }) => (
                                    <>
                                        <Row>
                                            <Col>
                                                <p style={{ fontWeight: "lighter" }}>
                                                    Click and drop the icon onto the Map and complete the pop up form.
                                                    <br />
                                                    For more information on how to add items to your map <a href="https://freshwaterfarmplan.co.nz/fwfp-support/drawing-map-features/" target="_blank" rel="noreferrer">Click Here</a>
                                                </p>
                                            </Col>
                                        </Row>
                                    </>
                                )}
                            />
                        </Row>
                        </Col>
                    }
                    {
                        Section == 'InfrastructureMap' &&
                        <Col><Row>
                            <h5 className="color-dark-teal">Identify Infrastructure&nbsp;&nbsp;&nbsp;
                                    <img className="featureIcon" src="/images/info_button_lt.png" data-tooltip-id="my-tooltip-16" onClick={(e) => e.stopPropagation()} /></h5>
                            <ReactTooltip opacity="1" className="overrideMe" globalCloseEvents={{ escape: true, clickOutsideAnchor: true, scroll: true, resize: true }} openOnClick="true" clickable="true" style={{ marginTop: "-1vh", backgroundColor: "#e2f2f3", color: "black", maxWidth: "25vw", fontWeight: "750", wordBreak: 'normal', overflowWrap: 'break-word' }}
                                id="my-tooltip-16"
                                place="top"
                                variant="info"
                                render={({ content, activeAnchor }) => (
                                    <>
                                        <Row>
                                            <Col>
                                                <p style={{ fontWeight: "lighter" }}>
                                                    For more information on adding infrastructure <a href="https://freshwaterfarmplan.co.nz/fwfp-support/adding-infrastructure-to-the-map/" target="_blank" rel="noreferrer">Click Here</a>
                                                </p>
                                            </Col>
                                        </Row>
                                    </>
                                )}
                            />
                        </Row>
                        </Col>
                    }
                    {
                        Section == 'InfrastructureRisk' &&
                        <Col><Row>
                            <h5 className="color-dark-teal">Infrastructure&nbsp;&nbsp;&nbsp;
                            <img className="featureIcon" src="/images/info_button_lt.png" data-tooltip-id="my-tooltip-16" onClick={(e) => e.stopPropagation()} /></h5>
                            <ReactTooltip opacity="1" className="overrideMe" globalCloseEvents={{ escape: true, clickOutsideAnchor: true, scroll: true, resize: true }} openOnClick="true" clickable="true" style={{ marginTop: "-1vh", backgroundColor: "#e2f2f3", color: "black", maxWidth: "25vw", fontWeight: "750", wordBreak: 'normal', overflowWrap: 'break-word' }}
                                id="my-tooltip-16"
                                place="top"
                                variant="info"
                                render={({ content, activeAnchor }) => (
                                    <>
                                        <Row>
                                            <Col>
                                                <p style={{ fontWeight: "lighter" }}>
                                                    For more information on adding infrastructure <a href="https://freshwaterfarmplan.co.nz/fwfp-support/adding-infrastructure-to-the-map/" target="_blank" rel="noreferrer">Click Here</a>
                                                </p>
                                            </Col>
                                        </Row>
                                    </>
                                )}
                            />
                        </Row>
                        </Col>
                    }
                    {
                        (Section == 'WaterwaysMap' || Section == 'WaterwaysRisk' ) &&
                        <Col><Row> <h5 className="text-capitalize fw-bold color-dark-teal">add Waterways&nbsp;&nbsp;&nbsp;
                                <img className="featureIcon" src="/images/info_button_lt.png" data-tooltip-id="my-tooltip-17" onClick={(e) => e.stopPropagation()} /></h5>
                            <ReactTooltip opacity="1" className="overrideMe" globalCloseEvents={{ escape: true, clickOutsideAnchor: true, scroll: true, resize: true }} openOnClick="true" clickable="true" style={{ marginTop: "-1vh", backgroundColor: "#e2f2f3", color: "black", maxWidth: "25vw", fontWeight: "750", wordBreak: 'normal', overflowWrap: 'break-word' }}
                                id="my-tooltip-17"
                                place="top"
                                variant="info"
                                render={({ content, activeAnchor }) => (
                                    <>
                                        <Row>
                                            <Col>
                                                <p style={{ fontWeight: "lighter" }}>
                                                    For more information on adding Waterways <a href="https://freshwaterfarmplan.co.nz/support-category/waterways-and-crossings/" target="_blank" rel="noreferrer">Click Here</a>
                                                </p>
                                            </Col>
                                        </Row>
                                    </>
                                )}
                            />
                        </Row>
                        </Col>
                    }
                    {
                        Section == 'Land and Erosion' &&
                        <Col><Row> <h5 className="text-capitalize fw-bold color-dark-teal"> Land and Erosion Areas;&nbsp;&nbsp;
                                <img className="featureIcon" src="/images/info_button_lt.png" data-tooltip-id="my-tooltip-18" onClick={(e) => e.stopPropagation()} /></h5>
                            <ReactTooltip opacity="1" className="overrideMe" globalCloseEvents={{ escape: true, clickOutsideAnchor: true, scroll: true, resize: true }} openOnClick="true" clickable="true" style={{ marginTop: "-1vh", backgroundColor: "#e2f2f3", color: "black", maxWidth: "25vw", fontWeight: "750", wordBreak: 'normal', overflowWrap: 'break-word' }}
                                id="my-tooltip-18"
                                place="top"
                                variant="info"
                                render={({ content, activeAnchor }) => (
                                    <>
                                        <Row>
                                            <Col>
                                                <p style={{ fontWeight: "lighter" }}>
                                                    For more information on Land and Erosion <a href="https://freshwaterfarmplan.co.nz/support-category/land-units/" target="_blank" rel="noreferrer">Click Here</a>
                                                </p>
                                            </Col>
                                        </Row>
                                    </>
                                )}
                            />
                        </Row>
                        </Col>
                    }
                    {
                        Section == 'Nutrients' &&
                        <Col><Row> <h5 className="text-capitalize fw-bold color-dark-teal">Nutrient Detail</h5>
                        </Row>
                        </Col>
                    }

                    {
                        Section != 'Community & Cultural Significance' && Section != 'InfrastructureMap' && Section != 'WaterwaysMap' && Section != 'InfrastructureRisk' && Section != 'WaterwaysRisk' && Section != 'Land and Erosion' && Section != 'Nutrients' &&
                        <Col sm="11"><Row> <h5 className="text-uppercase fw-bold color-dark-teal">{Section}</h5></Row>
                        </Col>
                    }
                </Row>
            </CardHeader>
            <CardBody>
                <Row>
                    <Col>
                        {Section == 'Community & Cultural Significance' &&

                            <label className="fw-bold info-text">Please indicate on the map any SITES or SPECIES which are significant to tangata whenua and/or threatened, either on the property, or down stream from the property.
                                <br />
                                These can include Taonga or threatened Species, or sites of high cultural value of community significance such as Wahi Tapu, fish spawning areas, drinking water protection zones, or recreational sites.
                            </label>
                        }
                        {Section == 'InfrastructureMap' &&
                            <label className="fw-bold info-text">Click an icon and place it on the map to mark your vineyard infrastructure.</label>
                        }
                        {Section == 'InfrastructureRisk' &&
                            <label className="fw-bold info-text">Review the mapped items, consider any that might contribute to environmental risk, and raise actions to mitigate.</label>
                        }
                        {(Section == 'WaterwaysMap' || Section == 'WaterwaysRisk') &&

                            <>
                                <Row>
                                    
                                    {itemModel.isMapOnly &&
                                        <>
                                            <Col sm="8">
                                        <Row>
                                            <Col>
                                                <label className="external-map-title">Definitions of waterways:</label>
                                            </Col>
                                        </Row>
                                        <Row >
                                            <Col  >
                                                <ul className="external-map-sub">
                                                    <li>Ephemeral – an area where water only flows during and shortly after rainfall, e.g. ditch that is dry most of the time, swale.</li>
                                                    <li>Intermittent – a waterway that ceases to flow for some periods of the year or at least twice every 5 years.</li>
                                                    <li>Perennial – a waterway that is full or continues to flow throughout the year for all or most years.</li>
                                                    <li>Groundwater - Groundwater is the water present beneath Earth's surface.</li>
                                                </ul>
                                            </Col>
                                        </Row>
                                    </Col>
                                     <Col>
                                            <Row>
                                                <Col>
                                                    <label className="external-map-title">External Map Layers&nbsp;&nbsp;&nbsp;
                                                        <img className="featureIcon" src="/images/info_button_dk.png" data-tooltip-id="my-tooltip-29" onClick={(e) => e.stopPropagation()} /></label>
                                                    <ReactTooltip opacity="1" className="overrideMe" globalCloseEvents={{ escape: true, clickOutsideAnchor: true, scroll: true, resize: true }} openOnClick="true" clickable="true" style={{ marginTop: "-1vh", backgroundColor: "#e2f2f3", color: "black", maxWidth: "25vw", fontWeight: "750", wordBreak: 'normal', overflowWrap: 'break-word' }}
                                                        id="my-tooltip-29"
                                                        place="top"
                                                        variant="info"
                                                        render={({ content, activeAnchor }) => (
                                                            <>
                                                                <Row>
                                                                    <Col>
                                                                        <p style={{ fontWeight: "lighter" }}>
                                                                            For more information on Waterways and Crossings <a href="https://freshwaterfarmplan.co.nz/fwfp-support/adding-waterways-guide/" target="_blank" rel="noreferrer">Click Here</a>
                                                                        </p>
                                                                    </Col>
                                                                </Row>
                                                            </>
                                                        )}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Input className="" type="checkbox" checked={gisLayerDetails.showGISLayer} onChange={handleGISLayerDetails} name="gisLayerDetails" id="gisLayerDetails" />
                                                    {'   '}<label className="external-map-sub">Show External Waterways Layer</label>
                                                </Col>
                                            </Row>
                                            <Row style={{ display: "none" }}>
                                                <Col>
                                                    <Input className="" type="checkbox" checked={gisLayerStockExclusionLandSlopeDetails.showGISLayer} onChange={handleGISLayerStockExclusionLandSlopeDetails} name="gisLayerStockExclusionLandSlopeDetails" id="gisLayerStockExclusionLandSlopeDetails" />
                                                    {'   '}<label className="external-map-sub">Show Stock Exclusion Low Slope Layer</label>
                                                </Col>
                                            </Row>
                                            <Row style={{ marginTop: "15px" }}>
                                                <Col>
                                                    <label className="external-map-title">Waterway Map Key</label>
                                                </Col>
                                            </Row>
                                            <Row >
                                                <Col><FaSlash color='#0000FF'></FaSlash> <span className="external-map-sub">  = 100% Fenced (or not required)</span></Col>
                                            </Row>
                                            <Row >
                                                <Col><FaSlash color='#FFA500'></FaSlash> <span className="external-map-sub">  = Not Fully Fenced</span> </Col>
                                            </Row>

                                        </Col>
                                        </>

                                    }
                                {!itemModel.isMapOnly &&
                                    <>
                                        <Col sm="12">
                                            <Row>
                                                <Col>
                                                    <label className="external-map-title">Definitions of waterways:</label>
                                                </Col>
                                            </Row>
                                            <Row >
                                                <Col  >
                                                    <ul className="external-map-sub">
                                                        <li>Ephemeral – an area where water only flows during and shortly after rainfall, e.g. ditch that is dry most of the time, swale.</li>
                                                        <li>Intermittent – a waterway that ceases to flow for some periods of the year or at least twice every 5 years.</li>
                                                        <li>Perennial – a waterway that is full or continues to flow throughout the year for all or most years.</li>
                                                        <li>Groundwater - Groundwater is the water present beneath Earth's surface.</li>
                                                    </ul>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </>

                                }
                                </Row>
                            </>

                        }

                        {Section == 'WaterwaysMap' && <label className="fw-bold info-text">Click an icon and place or draw on the map to mark the waterways on your vineyard.</label>}

                        {Section == 'Land and Erosion' &&
                            <label className="fw-bold info-text"> Click the icons then draw on the map to mark any relevant areas.</label>
                        }
                        {Section == 'Nutrients' &&
                            <label className="fw-bold info-text"> Consider how nutrients are applied to the vineyard.</label>
                        }
                    </Col>
                </Row>
                {
                    (itemModel.isMapOnly || itemModel.isMapRisk) &&
                    <Row>
                        <hr />
                        <Col>
                                <div className="panel-group" id="accordion-Edit" role="tablist" aria-multiselectable="true">
                                    {Section != 'Nutrients' &&
                                    <>
                                        <Row style={{ display: "none" }}>
                                            <Col>
                                                <label className="outlineLabel para-light-sm ">Click Icon then Map to add</label>
                                                <Button style={{ float: "right", marginLeft: "auto", marginRight: "-5px" }} className="btnClearSelection float-end" color="warning" size="sm" onClick={handleClearSelection}>
                                                    Clear Selection
                                                </Button>
                                            </Col>
                                        </Row>
                                <br />
                                <Row>
                                    {itemTypesList.map(type =>
                                        <Col key={uuid()} sm="12" className="style-item-display">
                                            <Row>
                                                <Col sm="12">
                                                    {isWaterways &&
                                                        <>
                                                            <img
                                                                className="featureIconNew"
                                                                src={"/images/ItemIcons/" + type.icon}
                                                                onClick={(event) => handleItemClick(event, type.id, type.markerType)}
                                                            />
                                                            {type.name == 'Lake' && type.markerType == 'circle' && <label className="itemTypeStyle itemTypeStyleFont"> {type.name} (circle)</label>}
                                                            {type.name == 'Lake' && type.markerType == 'polygon' && <label className="itemTypeStyle itemTypeStyleFont"> {type.name} </label>}
                                                            {type.name == 'Pond' && type.markerType == 'circle' && <label className="itemTypeStyle itemTypeStyleFont"> {type.name} (circle)</label>}
                                                            {type.name == 'Pond' && type.markerType == 'polygon' && <label className="itemTypeStyle itemTypeStyleFont"> {type.name} </label>}
                                                            {type.name != 'Pond' && type.name != 'Lake' && <label className="itemTypeStyle itemTypeStyleFont"> {type.name}</label>}
                                                        </>
                                                    }
                                                    {isLandErosion &&
                                                        <>
                                                            <img
                                                                className="featureIconNew"
                                                                src={"/images/ItemIcons/" + type.icon}
                                                                onClick={(event) => handleItemClick(event, type.id, type.markerType)}
                                                            />
                                                            {type.name == 'Areas that hold water' && type.markerType == 'circle' && <label className="itemTypeStyle itemTypeStyleFont"> {type.name} (circle)</label>}
                                                            {type.name == 'Areas that hold water' && type.markerType == 'polygon' && <label className="itemTypeStyle itemTypeStyleFont"> {type.name} </label>}
                                                            {type.name != 'Areas that hold water' && <label className="itemTypeStyle itemTypeStyleFont"> {type.name}</label>}
                                                        </>
                                                    }
                                                    {isOther && 
                                                        <>
                                                            <img
                                                                className="featureIconNew"
                                                                src={"/images/ItemIcons/" + type.icon}
                                                                onClick={(event) => handleItemClick(event, type.id, type.markerType)}
                                                            /> <label className="itemTypeStyle itemTypeStyleFont"> {type.name}</label>
                                                        </>
                                                    }
                                                </Col>
                                            </Row>
                                        </Col>
                                    )}
                                    
                                        </Row>
                                        <br />
                                    </>
                                    }
                            </div>
                        </Col>
                    </Row>
                }
                </CardBody>
        </Card>
    )
}
export default ItemTypeListViewForMap